import {
  AddressBook,
  AppleIcon,
  ArrowCounterClockwise,
  ArrowFatRight,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  BadgedUserProfileIcon,
  Bank,
  Basket,
  Bell,
  BellRinging,
  BellSimple,
  CalendarCheck,
  CalendarDots,
  CalendarPlus,
  CalendarX,
  CameraPlus,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  ChatDots,
  Check,
  CheckCircle,
  ChinaIcon,
  Circle,
  ClipboardText,
  Clock,
  Copy,
  CreditCard,
  Cube,
  CurrencyCircleDollar,
  Dot,
  DotOutline,
  DotsThreeOutline,
  DownloadSimple,
  EmailIcon,
  Envelope,
  Eye,
  EyeClosed,
  Files,
  FileText,
  Funnel,
  Gear,
  Gift,
  GoogleIcon,
  GoogleLogo,
  Headset,
  HourglassMedium,
  House,
  HouseSimple,
  Info,
  InstagramLogo,
  Invoice,
  Key,
  Lightning,
  Loading,
  LuceSparkle,
  MagnifyingGlass,
  MapPin,
  MapPinArea,
  MapPinLine,
  MapPinPlus,
  MapPinSimpleArea,
  Medal,
  MessengerLogo,
  Minus,
  MinusCircle,
  Notepad,
  NotePencil,
  Notification,
  Package,
  PasswordIcon,
  PawPrint,
  Phone,
  Play,
  Plus,
  PlusCircle,
  PlusSquare,
  Question,
  Receipt,
  SealPercent,
  ServiceAllIcon,
  ShareFat,
  ShieldCheck,
  ShoppingCart,
  SignOut,
  SmileySad,
  Sparkle,
  SquaresFour,
  StackPlus,
  Star,
  TelegramLogo,
  ThumbsUp,
  Timer,
  Translate,
  Trash,
  TrayArrowUp,
  UsaIcon,
  User,
  UserCircle,
  UserProfileIcon,
  UsersThree,
  UserSwitch,
  Wallet,
  Warning,
  WarningCircle,
  WhatsappIcon,
  WhatsappLogo,
  X,
  XCircle,
} from ".";

export const iconMap = {
  sealPercent: SealPercent,
  copy: Copy,
  houseSimple: HouseSimple,
  mapPin: MapPin,
  medal: Medal,
  bell: Bell,
  bellRinging: BellRinging,
  clipboardText: ClipboardText,
  signOut: SignOut,
  caretLeft: CaretLeft,
  caretRight: CaretRight,
  caretDown: CaretDown,
  caretUp: CaretUp,
  question: Question,
  x: X,
  invoice: Invoice,
  house: House,
  mapPinArea: MapPinArea,
  sparkle: Sparkle,
  squaresFour: SquaresFour,
  thumbsUp: ThumbsUp,
  circle: Circle,
  check: Check,
  shoppingCart: ShoppingCart,
  star: Star,
  currencyCircleDollar: CurrencyCircleDollar,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  arrowUpRight: ArrowUpRight,
  shareFat: ShareFat,
  notepad: Notepad,
  warning: Warning,
  chatDots: ChatDots,
  userCircle: UserCircle,
  eye: Eye,
  eyeClosed: EyeClosed,
  whatsappLogo: WhatsappLogo,
  whatsappIcon: WhatsappIcon,
  plusSquare: PlusSquare,
  clock: Clock,
  user: User,
  creditCard: CreditCard,
  fileText: FileText,
  shieldCheck: ShieldCheck,
  info: Info,
  checkCircle: CheckCircle,
  warningCircle: WarningCircle,
  xCircle: XCircle,
  mapPinPlus: MapPinPlus,
  calendarPlus: CalendarPlus,
  calendarX: CalendarX,
  funnel: Funnel,
  phone: Phone,
  key: Key,
  timer: Timer,
  plus: Plus,
  minus: Minus,
  minusCircle: MinusCircle,
  calendarDots: CalendarDots,
  mapPinLine: MapPinLine,
  receipt: Receipt,
  notePencil: NotePencil,
  dotsThreeOutline: DotsThreeOutline,
  mapPinSimpleArea: MapPinSimpleArea,
  magnifyingGlass: MagnifyingGlass,
  wallet: Wallet,
  arrowCounterClockwise: ArrowCounterClockwise,
  package: Package,
  files: Files,
  hourglassMedium: HourglassMedium,
  calendarCheck: CalendarCheck,
  basket: Basket,
  userSwitch: UserSwitch,
  cameraPlus: CameraPlus,
  trash: Trash,
  addressBook: AddressBook,
  usersThree: UsersThree,
  trayArrowUp: TrayArrowUp,
  cube: Cube,
  stackPlus: StackPlus,
  dotOutline: DotOutline,
  translate: Translate,
  bank: Bank,
  googleLogo: GoogleLogo,
  smileySad: SmileySad,
  dot: Dot,
  lightning: Lightning,
  telegramLogo: TelegramLogo,
  messengerLogo: MessengerLogo,
  instagramLogo: InstagramLogo,
  serviceAll: ServiceAllIcon,

  badgedUserProfile: BadgedUserProfileIcon,
  userProfile: UserProfileIcon,
  apple: AppleIcon,
  google: GoogleIcon,
  email: EmailIcon,
  password: PasswordIcon,
  luceSparkle: LuceSparkle,
  loading: Loading,
  chinaIcon: ChinaIcon,
  usaIcon: UsaIcon,
  gear: Gear,
  bellSimple: BellSimple,
  notification: Notification,
  envelope: Envelope,
  gift: Gift,
  plusCircle: PlusCircle,
  arrowFatRight: ArrowFatRight,
  pawPrint: PawPrint,
  downloadSimple: DownloadSimple,
  play: Play,
  headset: Headset,
};

export type IconNames = keyof typeof iconMap;
